import React, {Component} from 'react';
import {Modal, Typography} from 'antd';
import isReact from 'is-react';
import _ from 'underscore';
import {SplitCellsOutlined} from '@ant-design/icons';
import ReactDiffViewer, {DiffMethod} from "react-diff-viewer";
import classNames from 'classnames';
import { DiffResultKey } from '../../enums';

const { Text } = Typography;

///// Class Diagram /////
/**
 *                                <AuditInput/>
 *                                       |
 *             --------------------------|-----------------------
 *             |                         |                       |
 *    <AuditInputQuantityColumn/>      <DiffDMP/>           <DiffJs/>
 */

/**
 * Props:
 * - label:
 * - before:
 * - after:
 * - placeholder:
 * - rows:
 * - disabled:
 * - bordered
 * - packedRows:
 * - customRenderInput: {key: ()=>{...}}, an object of functions to override Audit Inputs renderFunctions.
 *                         eg: AuditInputQuantityColumn
 * - splitDiff: boolean, if true, will enable a popup modal of split diff when there's editted line
 * - diffDmpClassName: string, for split diff icon span
 * - inputAddonBeforeLabel: string, the label for 'addonBefore'. Eg used in Product -> General -> Default Sale Price
 * - overrideStatus: string, a value from enum DiffResultKey. whether to override and use this provided status
 */
export default class AuditInput extends Component {
    constructor(props) {
        super(props);
        this.state = {

            isSplitDiffModalVisible: false,
            hasScrollbar: false,

        };
        this.divRef = React.createRef();
    }

    componentDidMount() {
        const {
            splitDiff,
        } = this.props;

        // check if it has scrollbar
        const hasScrollbar = this.divRef.current?.scrollHeight > this.divRef.current?.clientHeight;
        this.setState({
            hasScrollbar,
        });

        if (splitDiff) {
            console.log('aaa hasScrollbar', {
                divRef: this.divRef,
                scrollHeight: this.divRef.current?.scrollHeight,
                clientHeight: this.divRef.current?.clientHeight,
                hasScrollbar});
        }
    }

    isEdit = () => {
        const { before, after } = this.props;
        if (isReact.element(before) && isReact.element(after))
            return !_.isEqual(before.props, after.props);

        return (before && after && before !== after);
    };

    isDelete = () => {
        const { before, after } = this.props;
        return before && !after;
    };

    isNew = () => {
        const { before, after } = this.props;
        return !before && after;
    };

    isUnchanged = () => {
        const { before, after } = this.props;
        if (isReact.element(before) && isReact.element(after))
            return _.isEqual(before.props, after.props);

        return (before && after && before === after);
    };

    renderEdit = () => {
        const { before, after, customRenderInput } = this.props;

        // specific render method for quantity col in panelItemsSalesPurchases
        if (customRenderInput?.getQuantityCol)
            return customRenderInput.getQuantityCol()?.props?.children; // the ui component

        if (customRenderInput?.renderEditDiv)
            return customRenderInput.renderEditDiv();

        return (
            <div>
                <div>
                    <Text
                        className="audit-input-text changed-before"
                    >
                        {before}
                    </Text>

                </div>
                <div>
                    <Text
                        className="audit-input-text changed-after"
                    >
                        {after}
                    </Text>

                </div>
            </div>
        );
    };

    renderDelete = () => {
        const { before } = this.props;
        return (
            <React.Fragment>
                {/* <Text type='danger'>-&nbsp;</Text> */}
                <Text
                    className="audit-input-text deleted"
                >
                    {before}
                </Text>
            </React.Fragment>
        );
    };

    renderNew = () => {
        const { after } = this.props;
        return (
            <div>
                {/* <Text type="success">+&nbsp;</Text> */}
                <Text
                    className="audit-input-text added"
                >
                    {after}
                </Text>
            </div>
        );
    };

    renderUnchanged = () => {
        const { after } = this.props;
        return <Text className="audit-input-text unchanged">{after}</Text>;
    };

    renderPlaceholder = () => {
        const { placeholder } = this.props;
        return <Text className="audit-input-text placeholder" disabled>{placeholder}</Text>;
    };

    renderTextDisplay = () => {
        const {
            overrideStatus,
        } = this.props;

        if (this.isDelete() || overrideStatus === DiffResultKey.removed)
            return this.renderDelete();
        if (this.isNew() || overrideStatus === DiffResultKey.added)
            return this.renderNew();
        if (this.isEdit() || overrideStatus === DiffResultKey.updated)
            return this.renderEdit();
        if (this.isUnchanged() || overrideStatus === DiffResultKey.same)
            return this.renderUnchanged();
        return this.renderPlaceholder();
    };

    getClassName = () => {
        const { bordered, disabled, className: propsClassName, inputAddonBeforeLabel } = this.props;
        // const baseClassName = 'expand-height--child ant-input';
        let className = `expand-height--child audit-input-box ${propsClassName || ''}`;

        if (bordered === false)
            return 'expand-height--child';

        if (inputAddonBeforeLabel)
            className += ' has-addon-before';
        if (disabled)
            className += ' disabled';
        // return disabled ? `${baseClassName} ant-input-disabled` : baseClassName;
        return className;
    };

    openSplitDiffModal = () => {
        this.setState({
            isSplitDiffModalVisible: true,
        });
    };

    closeSplitDiffModal = () => {
        this.setState({
            isSplitDiffModalVisible: false,
        });
    };

    renderSplitDiffModal = () => {
        const { isSplitDiffModalVisible, hasScrollbar } = this.state;
        const { before, after, diffDmpClassName } = this.props;

        return (
            <span
                className={
                    classNames(
                        'text-area-helper-icon',
                        'diff-dmp',
                        { 'has-scrollbar': hasScrollbar },
                        diffDmpClassName,
                    )
                }
            >
                <SplitCellsOutlined className="icon--expand" onClick={this.openSplitDiffModal} />
                <Modal
                    open={isSplitDiffModalVisible}
                    centered
                    onCancel={this.closeSplitDiffModal}
                    footer={null}
                >
                    <ReactDiffViewer
                        oldValue={before || ''}
                        newValue={after || ''}
                        hideLineNumbers
                        compareMethod={DiffMethod.WORDS}
                        splitView
                        styles={{
                        //https://github.com/praneshr/react-diff-viewer#overriding-styles
                            contentText: {
                                fontFamily: '"Roboto", sans-serif',
                            },
                        }}
                    />
                </Modal>
            </span>
        );
    };

    renderAuditInput = () => {
        const {
            maxRows,
            before,
            after,
            splitDiff,
            style,
        } = this.props;

        const maxRowsStyle = maxRows ? {
            overflow: 'hidden',
            display: '-webkit-box',
            '-webkit-box-orient': 'vertical',
            '-webkit-line-clamp': `${maxRows || 2}`,
        } : {};

        return (
            <>
                {splitDiff && (before !== after) ? this.renderSplitDiffModal() : undefined}
                <span
                    ref={this.divRef}
                    className={this.getClassName()}
                    style={{
                        minHeight: 32,
                        ...maxRowsStyle,
                        ...style, // from parent's style
                    }}
                >
                    {this.renderTextDisplay()}
                </span>
            </>
        );
    };

    render() {
        const { label, inputAddonBeforeLabel } = this.props;

        return (
            <>
                {inputAddonBeforeLabel && (
                    <span className="audit-input-addon expand-height--parent">
                        {inputAddonBeforeLabel}
                    </span>
                )}
                <span className="audit-input expand-height--parent">
                    {label ?
                        <span style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            paddingBottom: 4,
                        }}
                        >
                            {label}
                        </span> :
                        null}
                    {this.renderAuditInput()}
                </span>
            </>
        );
    }
}
